/* 카드결제 — 포트원(PortOne) V2 결제창 (백엔드 app/payments.py · app/orders.py)
   결제창에 넘기는 값(상점 · 채널 · 금액)은 서버가 주문을 만들며 준다. 결제 확인도 서버가 포트원에 물어서 한다.
   모바일 결제창은 페이지를 떠났다가 /checkout/complete 로 돌아오므로, 주문번호 등을 sessionStorage 에 남겨 둔다. */

export const PAY_KEY = "imeta_pay";

let configCache = null;

/* 카드결제를 보일지 — 키가 없거나(준비 전) 테스트 모드에서 등록 안 된 IP 면 false */
export function payConfig() {
  if (!configCache) {
    configCache = fetch("/api/payments/config", { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : { card: false }))
      .catch(() => ({ card: false }));
  }
  return configCache;
}

export function savePending(v) {
  try { sessionStorage.setItem(PAY_KEY, JSON.stringify(v)); } catch { /* 저장 못 해도 결제는 된다 */ }
}

export function takePending() {
  try {
    const v = JSON.parse(sessionStorage.getItem(PAY_KEY) || "null");
    sessionStorage.removeItem(PAY_KEY);
    return v;
  } catch {
    return null;
  }
}

/* 결제창 — PC 는 결과를 돌려받고, 모바일은 redirectUrl 로 떠난다(이 프로미스는 끝나지 않을 수 있다) */
export async function openCardPayment(params) {
  const PortOne = await import("@portone/browser-sdk/v2");
  return PortOne.requestPayment(params);
}

async function post(url, body) {
  const res = await fetch(url, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(typeof data.detail === "string" ? data.detail : "결제를 확인하지 못했습니다. MY 페이지에서 주문 상태를 확인해 주세요.");
    err.status = res.status;
    throw err;
  }
  return data;
}

/* 서버가 포트원에 결제를 조회해 맞으면 주문을 '결제 완료'로 바꾼다 */
export const completePayment = (paymentId) => post("/api/orders/pay/complete", { paymentId });

/* 결제창을 닫았거나 실패했을 때 — 결제가 안 된 주문만 서버가 취소한다 */
export const cancelUnpaid = (orderNo) => post(`/api/orders/${orderNo}/cancel`).catch(() => null);
